import React from 'react';
import { Spinner } from 'react-bootstrap';

const Loading = ({ title = 'Loading...' }) => {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9999
      }}
    >
      <div style={{ textAlign: 'center' }}>
        <Spinner animation="border" role="status" variant="primary" />
        {title && (
          <div style={{ marginTop: '10px', fontWeight: 'bold' }}>{title}</div>
        )}
      </div>
    </div>
  );
};

export default Loading;
